import React, { useState } from 'react';

interface Props {
    handleIsValid?: (valid: boolean) => void;
    required: boolean;
    needFileTypeValidation?: boolean;
    fileName?: string;
}
export const useValidation = ({ handleIsValid, required }: Props) => {
    const [errorMessage, setErrorMessage] = useState<string>('');

    const handleValidation = ({
        currentValue,
        prevValue,
        needFileTypeValidation,
        fileName,
    }: {
        currentValue: string;
        prevValue: string;
        needFileTypeValidation?: boolean;
        fileName?: string;
    }) => {
        // File type validation
        if (needFileTypeValidation && fileName) {
            const allowedTypes = [
                'mov',
                'jpeg',
                'jpg',
                'png',
                'svg',
                'pdf',
                'docx',
                'txt',
                'csv',
                'heic',
                'ssm',
                'sepf',
                'mp4',
                'zip',
            ];
            const fileExtension = fileName.split('.').pop()?.toLowerCase();

            if (!fileExtension || !allowedTypes.includes(fileExtension)) {
                handleIsValid?.(false);
                setErrorMessage(
                    'Accepted formats Images (.jpg, .jpeg, .png, .heic, .svg) | Video (.mov, .mp4) | Files (.pdf, .docx, .txt, .csv, .zip) | Diagnostic (.sepf, .ssm)'
                );
                return false;
            } else {
                setErrorMessage('');
            }
        }

        if (!required || !handleIsValid || currentValue.trim().length > 2000) {
            return;
        }

        currentValue = currentValue.trim();
        prevValue = prevValue.trim();
        if (prevValue !== '' && currentValue === '') {
            handleIsValid(false);
            setErrorMessage('This is a required field');
            return false;
        } else if (prevValue === '' && currentValue !== '') {
            handleIsValid(true);
            setErrorMessage('');
        }
    };

    return {
        handleValidation,
        errorMessage,
    };
};
